import vanillaJs from "./vanillaJs";
import react from "./react";
import vue from "./vue";

export default [vanillaJs, react, vue];
